const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths
    .filter((width) => width <= image["width"])
    .map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    })
    .join(", ");
};

const createImageElement = (image, classes, sizes, productTitle, widths) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  const srcWidths = widths || [165, 360, 533, 720, 940, 1066];
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  // 商品卡换色后手机用 400、桌面用 800，不按设备像素比升档。
  if (widths) {
    const mobileUrl = new URL(previewImage["src"], window.location.origin);
    const desktopUrl = new URL(previewImage["src"], window.location.origin);
    mobileUrl.searchParams.set("width", "400");
    desktopUrl.searchParams.set("width", "800");
    newImage.removeAttribute("srcset");
    newImage.removeAttribute("sizes");
    newImage.src = mobileUrl.href;
    newImage.dataset.desktopSrc = desktopUrl.href;
  } else {
    newImage.srcset = generateSrcset(previewImage, srcWidths);
  }
  newImage.loading = "lazy";
  return newImage;
};

const checkSwatches = () => {
  document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
    wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
      input.addEventListener("click", (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;

        if (event.currentTarget.checked && primaryImage) {
          if (wrapper.querySelector(".js-color-swatches-link")) {
            wrapper
              .querySelector(".js-color-swatches-link")
              .setAttribute("href", event.currentTarget.dataset.variantLink);
          }
          /* BOLODOO quick add variant url sync v1 */
          if (event.currentTarget.dataset.variantLink) {
            wrapper
              .querySelectorAll("modal-opener [data-product-url]")
              .forEach((trigger) => {
                trigger.setAttribute("data-product-url", event.currentTarget.dataset.variantLink);
              });
          }
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper
              .querySelector('.card__add-to-cart button[name="add"]')
              .setAttribute("aria-disabled", false);
            if (
              wrapper.querySelector(
                '.card__add-to-cart button[name="add"] > span'
              )
            ) {
              wrapper
                .querySelector('.card__add-to-cart button[name="add"] > span')
                .classList.remove("hidden");
              wrapper
                .querySelector(
                  '.card__add-to-cart button[name="add"] .sold-out-message'
                )
                .classList.add("hidden");
            }
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
              event.currentTarget.dataset.variantId;
          }

          const currentColor = event.currentTarget.value;

          jQuery.getJSON(
            window.Shopify.routes.root + `products/${handleProduct}.js`,
            function (product) {
              const variant = product.variants.filter(
                (item) =>
                  item.featured_media != null &&
                  item.options.includes(currentColor)
              )[0];

              if (variant) {
                const newPrimaryImage = createImageElement(
                  variant["featured_media"],
                  primaryImage.className,
                  "(min-width: 750px) 800px, 100px",
                  product.title,
                  [400, 800]
                );

                if (newPrimaryImage.src !== primaryImage.src) {
                  let flag = false;
                  if (secondaryImage) {
                    const secondaryImagePathname = new URL(secondaryImage.src)
                      .pathname;
                    const newPrimaryImagePathname = new URL(newPrimaryImage.src)
                      .pathname;

                    if (secondaryImagePathname == newPrimaryImagePathname) {
                      primaryImage.remove();
                      secondaryImage.classList.remove("media--second");
                      secondaryImage.classList.add("media--first");
                      flag = true;
                    }
                  }
                  if (flag == false) {
                    primaryImage.animate(
                      { opacity: [1, 0] },
                      { duration: 200, easing: "ease-in", fill: "forwards" }
                    ).finished;
                    setTimeout(function () {
                      primaryImage.replaceWith(newPrimaryImage);
                      const picture = newPrimaryImage.closest("picture");
                      const source = picture && picture.querySelector("source");
                      if (source && newPrimaryImage.dataset.desktopSrc) {
                        source.srcset = newPrimaryImage.dataset.desktopSrc;
                      }
                      newPrimaryImage.animate(
                        { opacity: [0, 1] },
                        { duration: 200, easing: "ease-in" }
                      );
                      if (secondaryImage) {
                        secondaryImage.remove();
                      }
                    }, 200);
                  }
                }
              }
            }
          );
        }
      });
    });
  });
};

function colorSwatches() {
  checkSwatches();

  document.addEventListener("shopify:section:load", function () {
    checkSwatches();
  });
}

(function () {
  colorSwatches();
})();
